<template>
  <div>
    <v-row
      justify="center"
      align="center"
      :class="{ 'mx-2': $vuetify.breakpoint.smAndUp }"
      style="padding-bottom: 0"
    >
      <v-col cols="12" class="px-0">
        <v-banner icon="mdi-comment-question-outline"
          >Frequently Asked Questions</v-banner
        >
        <v-progress-linear
          v-if="loadingFAQs"
          color="blue darken-2"
          indeterminate
        ></v-progress-linear>
      </v-col>
      <v-col
        cols="12"
        v-if="
          !$store.getters.retrieveIsCashCustomer &&
          !$store.getters.retrieveIsCncCustomer
        "
      >
        <v-row justify="center" align="center">
          <v-col cols="12">
            <v-card outlined shaped>
              <v-card-title>
                <v-icon class="mr-2">info</v-icon>Important Information
              </v-card-title>
              <v-card-text
                >The weight of some goods may vary marginally from that ordered
                and the price may change to reflect actual weight - if it weighs
                a little less you pay a little less and if it weighs a little
                more you pay a little more. Prices in ‘My basket’ are estimates
                only, however price per kilo are displayed.</v-card-text
              >
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row
      justify="center"
      align="center"
      :class="{ 'mx-2': $vuetify.breakpoint.smAndUp }"
      v-if="Object.keys(faqs).length"
    >
      <v-col cols="12" v-for="(faqType, i) in faqsType" :key="i">
        <v-row justify="start" align="start">
          <v-col cols="12" class="pb-0">
            <span class="title font-weight-bold">
              <v-icon class="mr-2">help_outline</v-icon>
              {{ faqType == "NA" ? "General Questions" : faqType }}
            </span>
            <!-- <v-expansion-panels focusable flat accordion class="mt-2 mb-4">
          <v-expansion-panel v-for="item in faqs[faqType]" :key="item.id">
            <v-expansion-panel-header class="subtitle-2">
              {{ item.question }}
              <template v-slot:actions>
                <v-icon color="info">add</v-icon>
              </template>
            </v-expansion-panel-header>
            <v-expansion-panel-content class="body-2 mt-4">
              <span v-html="item.answer"></span>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels> -->
          </v-col>

          <v-col cols="12">
            <v-row
              justify="start"
              align="start"
              v-for="item in faqs[faqType]"
              :key="item.id"
              class="lightDivider py-4"
            >
              <v-col cols="12" md="4">
                <h4>{{ item.question }}</h4>
              </v-col>
              <v-col cols="12" md="8"
                ><span class="body-1" v-html="item.answer"></span
              ></v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row
      v-else
      justify="center"
      align="center"
      :class="{ 'mx-2': $vuetify.breakpoint.smAndUp }"
    >
      <v-col cols="12">No FAQ's have been entered</v-col>
    </v-row>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import axios from "axios";

export default {
  name: "FAQ",

  data() {
    return {
      loadingFAQs: false,
    };
  },

  computed: {
    faqs() {
      if (this.$store.getters.retrieveFAQ) {
        return this.$store.getters.retrieveFAQ.items;
      } else {
        return [];
      }
    },
    faqsType() {
      return Object.keys(this.faqs);
    },
  },

  async activated() {
    this.loadingFAQs = true;
    await this.getFAQ();
    this.loadingFAQs = false;
  },

  methods: {
    ...mapActions(["getFAQ"]),
  },
};
</script>

<style lang="sass" scoped>
.v-expansion-panel
  border: 1px solid rgb(232, 232, 232)
</style>